import React, {useContext} from 'react';
import ReactDOM from 'react-dom/client';
import "./assets/styles/styles.scss"
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import {Provider} from "react-redux";
import {store} from "./store/store";
import {AllContext, AllContextFunc} from "./utils/contaxt";
import DocumentMeta from 'react-document-meta';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
      <BrowserRouter>
          <Provider store={store}>
              <AllContextFunc>
                    <App/>
              </AllContextFunc>
          </Provider>
      </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
